var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenezuela(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h39v24H0V0z",
    fill: "#CF142B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h39v16H0V0z",
    fill: "#00247D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h39v8H0V0z",
    fill: "#FC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.135 14.012l.625.442-.262.685.648-.412.625.442-.224-.697.648-.412-.787-.018-.224-.697-.262.685-.787-.018zm1.547-2.493l.416.617-.507.556.764-.174.415.617.057-.725.764-.174-.729-.274.057-.724-.507.555-.73-.274zm1.845-.75l.783.078.162.71.322-.662.782.077-.584-.487.322-.663-.683.362-.583-.487.162.71-.683.363zm2.549-1.21l.708.318-.108.72.545-.524.709.318-.371-.641.546-.524-.775.128-.371-.641-.108.72-.775.127zm2.822-.319l.547.523-.37.641.707-.318.547.522-.11-.719.708-.318-.775-.127-.11-.72-.369.642-.775-.126zm2.783.607l.32.664-.585.486.782-.076.32.664.165-.71.782-.077-.681-.363.163-.71-.585.486-.681-.364zm1.727 2.406l.764.171.06.725.413-.618.765.171-.51-.553.414-.619-.728.276-.51-.554.06.725-.728.276zm1.377 1.784l.645.417-.23.694.629-.437.644.417-.256-.687.629-.437-.787.012-.257-.687-.23.695-.787.013z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/venezuela.f77d8815.svg";
export { SvgVenezuela as ReactComponent };